// 接口地址
const language = "cn";

export default {
  language
};



// WEBPACK FOOTER //
// ./src/global/global.js